import React, { FC } from 'react'

import { IconNeutralTobiProps } from './IconNeutralTobi.types'
import * as Styled from './styles/IconNeutralTobi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNeutralTobi: FC<IconNeutralTobiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconNeutralTobiProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconNeutralTobiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 54 56' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd'>
          <path
            d='M42.737 23.3h-.165a5.812 5.812 0 0 1-.399.29 15.22 15.22 0 0 1-3.55 1.74 29.86 29.86 0 0 1-4.655 1.16 42.633 42.633 0 0 1-14.012 0c-3.715-.653-6.772-1.788-8.581-3.214-.8-.024-1.552.363-2.046.99a4.32 4.32 0 0 0-.8 1.813v6.425c0 .338.024.677.048.991.822 10.436 9.709 18.19 19.866 17.369 9.004-.75 16.151-8.093 16.904-17.369.023-.338.047-.653.047-.99v-6.404c-.164-.652-.423-1.28-.8-1.811a2.566 2.566 0 0 0-1.857-.99z'
            fill='#EBEBEB'
          />
          <path
            d='M3.984 25.874c0 .143-.024.262-.024.405v4.389c0 .644.117 1.288.327 1.884.749 2.075 2.643 3.506 4.816 3.601a19.696 19.696 0 0 1-.397-2.623 12.126 12.126 0 0 1-.046-.978c-.016-.334-.016-.508 0-.524v-5.82c.14-.645.397-1.265.794-1.79a2.45 2.45 0 0 1 2.034-.977c1.8 1.383 4.84 2.528 8.534 3.172a42.619 42.619 0 0 0 13.933 0 30.244 30.244 0 0 0 4.606-1.145 15.18 15.18 0 0 0 3.53-1.717c.14-.095.28-.19.397-.286h.164a2.451 2.451 0 0 1 1.87.978 4.24 4.24 0 0 1 .795 1.788v6.345c0 .334-.023.668-.047.978a19.73 19.73 0 0 1-.397 2.624 5.442 5.442 0 0 0 4.793-3.578 5.67 5.67 0 0 0 .327-1.86v-2.6c.047-.478.047-.978.047-1.527C50.11 13.543 39.776 3 27.035 3 14.551 3 4.334 13.137 3.984 25.874z'
            fill='#E60000'
          />
          <path
            d='M31.01 17.7a5.004 5.004 0 0 1-1.46 1.756 5.447 5.447 0 0 1-4.895.94 5.81 5.81 0 0 1-3.239-2.423 6.499 6.499 0 0 1-.742-1.632c0-.05-.024-.074-.024-.124a4.603 4.603 0 0 1-.173-.989c-.025-.346-.05-.692-.025-1.038v-.1c.025-.493.099-.988.222-1.458.446-1.78 1.46-3.363 2.844-4.55a9.716 9.716 0 0 1 2.769-1.631c.272-.1.57-.198.84-.272l.52-.149c.42-.099.84-.173 1.286-.222.42-.05.865-.05 1.286 0 .073 0 .148.024.197.05-1.904.42-3.288 2.1-3.288 4.054v.124c.766.148 1.483.42 2.15.816.545.346 1.04.766 1.41 1.286l.074.123c.273.396.47.84.618 1.31.149.47.223.965.248 1.46v.197a5.8 5.8 0 0 1-.618 2.473M26.04 4.843c-5.613 0-10.138 4.55-10.138 10.138s4.55 10.137 10.138 10.137 10.138-4.549 10.138-10.137c0-5.612-4.55-10.138-10.138-10.138'
            fill='#FFF'
          />
          <path
            d='M18.45 40.5h15.9a1.05 1.05 0 1 1 0 2.1h-15.9a1.05 1.05 0 1 1 0-2.1zm-2.456-8.243a2.778 2.778 0 0 0 3.364 1.994 2.787 2.787 0 0 0 1.992-1.994c.366-1.49-.527-3.003-1.992-3.37-1.487-.366-2.998.528-3.364 1.994-.046.23-.092.459-.092.688v.046c0 .23.046.435.092.642m14.768.02c.389 1.475 1.897 2.338 3.36 1.974a2.77 2.77 0 0 0 1.987-1.974c.045-.159.068-.317.068-.5v-.18a2.75 2.75 0 0 0-2.719-2.792c-1.53-.022-2.787 1.18-2.81 2.7 0 .273.023.523.114.772'
            fill='#4A4D4E'
          />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNeutralTobi
